<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="700px">
      <template v-slot:activator="{ on }">
        <v-btn id="btn-level" color="primary" v-on="on">
          Group Level
        </v-btn>
      </template>
      <v-card class="rounded-12">
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="saveConfirm" class="pa-0">
            <v-card-title
              class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
            >
              <span class="pa-0">Group Level of {{ div.name }}</span>
              <v-spacer></v-spacer>
              <v-icon
                @click="dialog = false"
                color="white"
                class="fs-18"
                style="font-size: 20px !important; margin-right: -4px !important"
              >
                close
              </v-icon>
            </v-card-title>
            <v-perfect-scroll class="level-dialog">
              <v-card-text>
                <v-container class="pa-0 form-filter pb-2">
                  <v-row
                    class="px-3 pb-3"
                    v-for="(item, index) in level"
                    :key="index"
                  >
                    <v-col cols="2 pt-2 py-0">
                      <span class="fs-16 lightblack--text"
                        >Level {{ index + 1 }}</span
                      >
                    </v-col>
                    <v-col cols="5 py-0">
                      <ValidationProvider
                        name="Level Name"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          id="version"
                          single-line
                          outlined
                          dense
                          placeholder="Level Name"
                          v-model="item.name"
                          required
                          :error-messages="errors"
                          hide-details
                        ></v-text-field>
                        <!-- <v-checkbox
                          v-model="item.is_non_brand_level"
                          @change="
                            handleNonBrand(item, item.is_non_brand_level)
                          "
                          label="Non Brand"
                          dense
                          class="mt-0"
                        ></v-checkbox> -->
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="auto" v-if="index === 0" class="pl-0 py-0">
                      <v-btn
                        dark
                        color="green"
                        class="mt-1"
                        @click="addRow(level.length)"
                        ><v-icon>add</v-icon></v-btn
                      >
                    </v-col>
                    <v-col cols="auto" v-if="index !== 0" class="pl-0 py-0">
                      <v-btn
                        dark
                        color="red"
                        class="mt-1"
                        @click="removeRow(index)"
                        ><v-icon>delete_outline</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-perfect-scroll>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-2" type="submit">
                Ok
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import ProgressDialog from '../progress_dialog';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog
  },
  props: {
    div: {
      type: Object
    },
    isDraft: {
      type: Boolean
    }
  },
  data() {
    return {
      progressDialogLoading: false,
      dialog: false,
      level: [
        {
          id: null,
          name: '',
          level: 1,
          is_non_brand_level: false
        }
      ],
      timeout: null
    };
  },
  computed: {
    div_id() {
      return this.div.division_id;
    }
  },
  watch: {
    div_id(val) {
      if (val && !this.isDraft) {
        this.getLevel();
      }
    }
  },
  async mounted() {
    this.progressDialogLoading = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.progressDialogLoading = false;
      if (this.isDraft) {
        this.level = this.div.level.level;
        const param = {
          division_id: this.div_id,
          level: this.level
        };
        this.$emit('postLevel', param);
        if (this.div.level.level.length === 0) {
          this.level = this.div.level.level.push({
            id: null,
            name: '',
            level: 1,
            is_non_brand_level: false
          });
        }
      }
    }, 900);
  },
  methods: {
    handleNonBrand(item, level) {
      for (let i = 0; i < this.level.length; i++) {
        this.level[i].is_non_brand_level = false;
      }
      item.is_non_brand_level = level ? true : false;
    },
    getLevel() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('dynamic/getLevel', { division_id: this.div_id })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            if (data.data.length === 0) {
              this.level = [
                {
                  id: null,
                  name: '',
                  level: 1,
                  is_non_brand_level: false
                }
              ];
            } else {
              this.level = data.data;
              const param = {
                division_id: this.div_id,
                level: this.level
              };
              this.$emit('postLevel', param);
            }
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    addRow(i) {
      return this.level.push({
        id: null,
        name: '',
        level: i + 1,
        is_non_brand_level: false
      });
    },
    removeRow(index) {
      return this.level.splice(index, 1);
    },
    async saveConfirm() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        if (this.div_id !== null) {
          const param = {
            division_id: this.div_id,
            level: this.level
          };
          this.$emit('postLevel', param);
          this.dialog = false;
          // Swal.fire({
          //   title: '',
          //   text: `Are you sure want to save this group level?`,
          //   type: 'question',
          //   showCancelButton: true,
          //   confirmButtonText: `Yes, save it!`,
          //   cancelButtonText: 'No, cancel it!'
          // }).then(result => {
          //   if (result.value) {
          //     this.save();
          //   } else if (result.dismiss === Swal.DismissReason.cancel) {
          //     Swal.fire(
          //       'Cancelled',
          //       `Level has been cancelled to save.`,
          //       'error'
          //     );
          //   }
          // });
        } else {
          Swal.fire('Failed', `Please select division.`, 'error');
        }
      }
    },
    save() {
      this.progressDialogLoading = true;
      const param = {
        division_id: this.div_id,
        level: this.level
      };
      return this.$store
        .dispatch('dynamic/saveLevel', param)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire('Success!', data.message.text_en, 'success');
            this.dialog = false;
            this.getLevel();
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    }
  }
};
</script>
<style>
.level-dialog {
  max-height: 396px;
  overflow: auto;
}
</style>
